var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 12 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.667 11.487V5.972c0-2.423 0-3.634.78-4.386C2.23.833 3.487.833 6 .833s3.771 0 4.552.753c.781.752.781 1.963.781 4.386v5.515c0 1.537 0 2.306-.515 2.581-.998.533-2.87-1.245-3.758-1.78-.516-.31-.773-.465-1.06-.465s-.545.155-1.06.465c-.889.535-2.76 2.313-3.758 1.78-.515-.275-.515-1.044-.515-2.58"
})));
export { SvgBookmarks as ReactComponent };
export default __webpack_public_path__ + "static/media/Bookmarks.3fca32d5.svg";